import React from 'react';

// INTERFACES
import { IDropdown, IDropdownItem } from '../../interfaces/Dropdown.interface';

// STYLES
import { 
  Container, 
  Label, 
  Select 
} from './styles';

const Dropdown: React.FC<IDropdown> = ({ 
  id, 
  items,
  label, 
  name
}: IDropdown) => {
  return (
    <Container>
      <Label>{label}</Label>
      <Select id={id} name={name}>
        {items.map((item: IDropdownItem, key: number) => {
          return (
            <option key={key} value={item.value}>
              {item.name}
            </option>
          );
        })}
      </Select>
    </Container>
  );
};

export default Dropdown;
